import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/mobile_img.png'


const _withScopeId = n => (_pushScopeId("data-v-acb087c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("section", { class: "main-visual" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title-text container" }, [
    /*#__PURE__*/_createElementVNode("h4", null, "All about Uber sheep"),
    /*#__PURE__*/_createElementVNode("hr"),
    /*#__PURE__*/_createElementVNode("h2", null, [
      /*#__PURE__*/_createTextVNode(" Uber Sheepの"),
      /*#__PURE__*/_createElementVNode("br"),
      /*#__PURE__*/_createTextVNode(" すべて ")
    ]),
    /*#__PURE__*/_createElementVNode("hr")
  ])
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mobile-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: ""
  })
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _hoisted_2
  ], 64))
}